import { useMutation, useQueryClient } from 'react-query';
import { getSubscriptionBlockUseCases } from '@subscriptions/composition';
import type { CreateSubscriptionBlockDto, SubscriptionBlockViewDto } from '@subscriptions/application/dtos';

/**
 * Hook for creating a new subscription block.
 *
 * @returns Mutation result for creating a subscription block
 */
export const useCreateSubscriptionBlock = () => {
  const queryClient = useQueryClient();
  const { createSubscriptionBlock } = getSubscriptionBlockUseCases();

  return useMutation<SubscriptionBlockViewDto, Error, CreateSubscriptionBlockDto>(
    (dto) => createSubscriptionBlock.execute(dto),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['subscriptions', 'blocks', 'list']);
      },
    },
  );
};
